import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import permissionsReducer from "@alboom/alboom-cerberus";
import page from "./page";
import editor from "./editor";
import header from "./header";
import user from "./user";

const rootReducer = combineReducers({
  page,
  editor,
  header,
  user,
  i18n: i18nReducer,
  permissions: permissionsReducer,
});

export default rootReducer;
